/* eslint-disable */
import { createGenerateClassName } from '@material-ui/core/styles';

const generateClassName = createGenerateClassName();

export default generateClassName;
